module.exports = __webpack_public_path__ + "img/section-5--img.92726645.jpg";